import React from 'react';
import { Input } from 'antd';
import { Colors } from 'works/legacy/lib/style-helper';

type TextAreaProps = React.ComponentProps<typeof Input.TextArea>;

export type Props = TextAreaProps & {
  autoSize?:
    | boolean
    | {
        minRows: number;
        maxRows?: number;
      };
  maxLength?: number;
};

export const TextArea = ({
  maxLength,
  onChange = () => {},
  autoSize,
  ...props
}: Props) => {
  const messageCurrentLength = props?.value ? String(props?.value).length : 0;

  const textAreaCountInvalidClass =
    maxLength && messageCurrentLength > maxLength
      ? 'theme-textarea__counter--error'
      : '';

  const customSize = autoSize ? autoSize : { minRows: 3 };

  return (
    <>
      <div className="theme-textarea">
        <Input.TextArea
          {...props}
          autoSize={customSize}
          onChange={onChange}
          maxLength={maxLength}
        />
        {maxLength && (
          <div
            className={`${textAreaCountInvalidClass} theme-textarea__counter`}
          >
            {messageCurrentLength}/{maxLength}
          </div>
        )}
      </div>
      <style jsx>{`
        .theme-textarea__counter {
          color: ${Colors.midnightLighter};
          font-size: 13px;
          text-align: right;
          position: absolute;
          bottom: -20px;
          right: 0;
        }
        .theme-textarea__counter.theme-textarea__counter--error {
          color: ${Colors.coral};
        }
      `}</style>
    </>
  );
};
